import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { MeshPhysicalMaterial, MeshStandardMaterial } from "three";
import { PaneelGLTFResult } from "../paneel/PaneelType";
import {
  defaultDoorHeight,
  defaultDoorWidth,
} from "shared/utils/doorSceneConstants";
import { TaatsGLTFResult } from "../taats/TaatsType";
import { SchuifGLTFResult } from "../schuif/SchuifType";
import { ScharnierGLTFResult } from "../scharnier/ScharnierType";
import { deIjsselGeometry } from "./deIjsselGeometry";

export const DeIjsselLayout = ({
  chosenMaterial,
  nodes,
  doorIndex,
}: {
  chosenMaterial: MeshPhysicalMaterial | MeshStandardMaterial;
  nodes:
    | TaatsGLTFResult["nodes"]
    | SchuifGLTFResult["nodes"]
    | PaneelGLTFResult["nodes"]
    | ScharnierGLTFResult["nodes"];
  doorIndex: number;
}) => {
  const { layout, getConfigurationWidth, getConfigurationHeight } =
    useConfigurationOptionsContext();

  const scaleDoorY = getConfigurationHeight(0) / defaultDoorHeight;
  const scaleDoorX = getConfigurationWidth(doorIndex) / defaultDoorWidth;
  const mirrorCurve = layout?.code === "deijssel1dubbel";
  const curveRotationY = mirrorCurve ? Math.PI : 0;

  return (
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.beam_deijssel.geometry}
      material={chosenMaterial}
      scale-y={scaleDoorY}
      scale-x={scaleDoorX}
      rotation-y={curveRotationY}
      position-y={deIjsselGeometry.offsetMm / 1000}
    />
  );
};
